import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-doc-preview',
  templateUrl: './doc-preview.component.html',
  styleUrls: ['./doc-preview.component.scss']
})
export class DocPreviewComponent implements OnInit {
  @ViewChild ('preview', {static: true}) preview: TemplateRef<any>;

  @Input('thumbnail_width') thumbnail_width: number;
  @Input('thumbnail_height') thumbnail_height: number;
  @Input('asset') asset: any;
  @Input('assets') assets: any;


  type = 'image';
  pdf: any;
  constructor(public dialog: MatDialog, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    const split = this.asset.split('.');
    const ext = split[split.length - 1];
    if(ext == 'pdf'){
      this.type = 'pdf';
    }
    if(this.type == 'pdf'){
      this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(this.asset);
    }
  }
  openDialog(){

    const d = this.dialog.open(this.preview,{
      width: '900px',
      maxWidth:'75vw !important'
    });
  }

  sanitize(asset){
    return this.sanitizer.bypassSecurityTrustResourceUrl(asset);
  }
}
